import React, { Component } from 'react';
import {
    Form, Input, InputNumber, Modal, DatePicker,
} from 'antd';
import moment from 'moment';

class MachineAddView extends Component {
    constructor(props) {
        super(props);
        this.handleOk = this.handleOk.bind(this);
    }

    onChange(date, dateString) {
        console.log(date, dateString);
    }

    disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    handleOk() {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleCreate(values);
                this.props.form.resetFields();
            }
        });
    }


    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { machine } = this.props;
        return (
            <Modal
                title="Administración Maquinas"
                visible={this.props.openForm}
                onOk={this.handleOk}
                onCancel={this.props.onCancel}
            >
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item
                        {...formItemLayout}
                        label="Nombre"
                    >
                        {getFieldDecorator('name', {
                            initialValue: (machine != null) ? machine.name : '',
                            rules: [{ required: true, message: 'Ingrese el nombre de la maquina' }],
                        })(
                            <Input />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Marca"
                    >
                        {getFieldDecorator('brand', {
                            initialValue: (machine) ? machine.brand : '',
                            rules: [{ required: true, message: 'Ingrese la marca de la maquina' }],
                        })(
                            <Input />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Modelo"
                    >
                        {getFieldDecorator('model', {
                            initialValue: (machine) ? machine.model : '',
                            rules: [{ required: true, message: 'Ingrese el modelo de la maquina' }],
                        })(
                            <Input />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Número de Serie"
                    >
                        {getFieldDecorator('serial', {
                            initialValue: (machine) ? machine.serial : '',
                            rules: [{ required: true, message: 'Ingrese el número de serie de la maquina' }],
                        })(
                            <Input />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Año"
                    >
                        {getFieldDecorator('year', {
                            initialValue: (machine) ? machine.year : '',
                            rules: [{ required: true, message: 'Ingrese el año de la maquina' }],
                        })(
                            <Input />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Precio en $"
                    >
                        {getFieldDecorator('machinePrice', {
                            initialValue: (machine) ? machine.price : '',
                            rules: [{ required: true, message: 'Ingrese el precio de la máquina' }],
                        })(
                            <Input type="number" />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Ubicación"
                    >
                        {getFieldDecorator('location', {
                            initialValue: (machine) ? machine.location : '',
                            rules: [{ required: true, message: 'Ingrese la ubicación de la máquina' }],
                        })(
                            <Input />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Estado"
                    >
                        {getFieldDecorator('status', {
                            initialValue: (machine) ? machine.status : 100,
                            rules: [{ required: true }],
                        })(
                            <InputNumber
                                min={0}
                                max={100}
                                formatter={value => `${value}%`}
                                parser={value => value.replace('%', '')}
                            />,
                        )}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label="Chequeo en dias"
                    >
                        {getFieldDecorator('dayscheck', {
                            initialValue: (machine) ? machine.dayscheck : 7,
                            rules: [{ required: true }],
                        })(
                            <InputNumber
                                min={7}
                                max={365}
                            />,
                        )}
                    </Form.Item>
                    {/* <Form.Item
                        {...formItemLayout}
                        label="Próximo Servicio"
                    >
                        {getFieldDecorator('service', {
                            initialValue: (machine) ? moment(machine.service) : '',
                            rules: [{ required: true }],
                        })(
                            <DatePicker onChange={this.onChange} disabledDate={this.disabledDate} />,
                        )}
                    </Form.Item> */}
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(MachineAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineAddView.js